/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import * as React from 'react';

const breadMaker = (id = '') => {
  const [fistletter, ...restName] = String(id).slice(1);
  let name = '';
  if (fistletter) {
    const rest = (restName?.join?.('') || restName).replace(/[-_]/g, ' ');
    name = `${fistletter.toUpperCase()}${rest}`;
  }
  return {
    id,
    name
  };
};
const Breadcrumb = () => {
  const { id, name } = breadMaker(typeof window !== 'undefined' ? window.location.pathname : '');
  return (
    <script
      type='application/ld+json' dangerouslySetInnerHTML={{
        __html: JSON.stringify({
          '@context': 'http://schema.org',
          '@type': 'BreadcrumbList',
          itemListElement: [{
            '@type': 'ListItem',
            position: 1,
            item: {
              '@id': 'https://www.hypnose-venture.fr/',
              name: 'Hypnose Venture',
              image: 'https://www.hypnose-venture.fr/img/freedom.jpg'
            }
          },
          {
            '@type': 'ListItem',
            position: 2,
            item: {
              '@id': `https://www.hypnose-venture.fr${id}`,
              name,
              image: 'https://www.hypnose-venture.fr/img/freedom.jpg'
            }
          }]
        })
      }}
    />
  );
};

export default Breadcrumb;
